import _ from 'lodash';

const moduleName = 'ProspectingProjectGrantStat';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
